import { useSyncExternalStore } from 'react'
import { getZohoCallbackResult, watchZohoCallbackResult } from '../lib/zohoResult'

/** What the Zoho callback said, until something clears it. */
export function useZohoCallbackResult() {
  return useSyncExternalStore(watchZohoCallbackResult, getZohoCallbackResult, () => '')
}
